<template>
  <v-tooltip top>
    <template v-slot:activator="{ props }">
      <span v-if="processing.indexOf(mocId) > -1 || status === 'processing'"
        ><v-progress-circular indeterminate size="20"></v-progress-circular
      ></span>
      <span v-else>
        <span v-if="adminRoles.find(x => x === 'ProcessManager' || x === 'ITSupport')">
          <v-icon v-bind="props" v-if="status !== 'processing'" @click="download">mdi-archive-arrow-down-outline</v-icon>
        </span>
      <span v-else-if="isEmoc1Archive">
        <v-icon v-bind="props" v-if="status !== 'processing'" @click="download">mdi-archive-arrow-down-outline</v-icon>
        </span>
      </span>
    </template>
    <span> {{ $t('Download_Archive') }}</span>
  </v-tooltip>
</template>

<script>
import { mapState } from 'vuex'
import MocService from '@/services/moc.service'

export default {
  name: 'ArchiveButton',
  data() {
    return {
      interval: undefined,
      status: 'done'
    }
  },
  props: {
    mocId: {
      required: true
    },
    isEmoc1Archive: {
      default: false
    }
  },
  computed: {
    ...mapState('currentUserAdminRoles', ['adminRoles']),
    ...mapState('archivingMocs', ['processing', 'errors'])
  },
  methods: {
    downloadArchive() {
      console.log('end', new Date())
      this.$store.dispatch('archivingMocs/downloadMocArchive', this.mocId).then(url => {
        if (!url) return
        const a = document.createElement('a')
        a.href = url
        a.download = `${this.mocId}.zip`
        a.style.display = 'none'
        a.rel = 'noopener'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      })
    },
    getArchiveStatus() {
      return MocService.getArchiveStatus(this.mocId)
    },
    longPollArchiveStatus() {
      if (!this.interval) {
        clearInterval(this.interval)
        this.interval = setInterval(() => {
          this.getArchiveStatus(this.mocId)
            .then(status => {
              this.status = status
              if (status === 'done') {
                this.downloadArchive()
              }

              if (status !== 'processing') {
                clearInterval(this.interval)
                this.interval = undefined
              }
            })
            .catch(() => {
              clearInterval(this.interval)
              this.interval = undefined
            })
        }, 2000)
      }
    },
    requestArchive() {
      console.log('start', new Date())
      this.status = 'processing'
      this.getArchiveStatus(this.mocId).then(status => {
        this.status = status
        if (status === 'done') {
          this.downloadArchive()
        } else {
          MocService.requestArchive(this.mocId).then(() => {
            this.longPollArchiveStatus()
          })
        }
      })
    },
    downloadEmoc1Archive() {
      this.$store.dispatch('archivingMocs/downloadEmoc1Archive', this.mocId)
    },
    retry() {
      this.$store.dispatch('archivingMocs/retry', this.mocId)
    },
    isEmoc1Id(mocId) {
      return mocId.toLowerCase().startsWith('emoc-')
    },
    download() {
      if (this.isEmoc1Id(this.mocId)) {
        this.downloadEmoc1Archive()
      } else {
        this.requestArchive()
      }
    }
  }
}
</script>

<style></style>
